module.exports = __webpack_public_path__ + "static/media/iride_pass_new.c2f54dab.png";